import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

const Card = ({ image, title, content, activeSection }) => {
  const navigate = useNavigate();
  const cardRef = useRef(null);

  const [transform, setTransform] = useState({
    rotateX: 0,
    rotateY: 0,
    translateX: 0,
    translateY: 0,
  });

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    const rect = card.getBoundingClientRect();

    const mouseX = e.clientX - rect.left - rect.width / 2;
    const mouseY = e.clientY - rect.top - rect.height / 2;

    setTransform({
      rotateX: -(mouseY / rect.height) * 30,
      rotateY: (mouseX / rect.width) * 30,
      translateX: (mouseX / rect.width) * -40,
      translateY: (mouseY / rect.height) * -40,
    });
  };

  const resetCard = () => {
    setTransform({
      rotateX: 0,
      rotateY: 0,
      translateX: 0,
      translateY: 0,
    });
  };

  return (
    <div
      className="card-wrap"
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={resetCard}
    >
      <div
        className="card"
        style={{
          transform: `rotateY(${transform.rotateY}deg) rotateX(${transform.rotateX}deg)`,
        }}
      >
        <div
          className="card-bg"
          style={{
            backgroundImage: `url(${image})`,
            transform: `translateX(${transform.translateX}px) translateY(${transform.translateY}px)`,
          }}
        />

        <div className="card-info">
          <h1>{title}</h1>

          <p>{content}</p>

          <button
            className="card-btn"
            onClick={() =>
              navigate("/our-services", {
                state: {
                  activeSection,
                },
              })
            }
          >
            Read More
          </button>
        </div>
      </div>
    </div>
  );
};

const Services = () => {
  const cards = [
    {
      image: "https://primary.jwwb.nl/pexels/19/19825346.jpeg?enable-io=true&crop=1.3333%3A1&width=532",
      title: "CQC Services",
      content: "Navigate complex regulations and improve your CQC ratings.",
      activeSection: "cqc-services",
    },
    {
      image: "https://primary.jwwb.nl/pexels/78/7876379.jpeg?enable-io=true&crop=1.3333%3A1&width=532",
      title: "Care Home Sales",
      content: "Expert guidance throughout the buying and selling process.",
      activeSection: "care-home-sales",
    },
    {
      image: "https://plus.unsplash.com/premium_photo-1661761077411-d50cba031848",
      title: "Accounting",
      content: "Tailored financial support for care providers.",
      activeSection: "accounting",
    },
    {
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRnb9YuXBp_jzaE5AOlAteiGP5lsCWY7O8nfw&s",
      title: "Software",
      content: "ERP, governance, auditing and rota solutions.",
      activeSection: "software",
    },
    {
      image: "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/care-staff-high.jpg?enable-io=true&crop=1.3324%3A1%2Coffset-x37&width=532",
      title: "Operational Management",
      content: "Training and operational support for care services.",
      activeSection: "operational-management",
    },
  ];

  return (
    <section className="Services">
      <h1 className="title">Our Tailored Services</h1>

      <div className="container">
        {cards.map((card) => (
          <Card
            key={card.activeSection}
            image={card.image}
            title={card.title}
            content={card.content}
            activeSection={card.activeSection}
          />
        ))}
      </div>
    </section>
  );
};

export default Services;


















































// import React, { useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";

// const Card = ({ image, title, content, activeSection }) => {
//   const navigate = useNavigate();
//   const cardRef = useRef(null);

//   const [transform, setTransform] = useState({
//     rotateX: 0,
//     rotateY: 0,
//     translateX: 0,
//     translateY: 0,
//   });

//   const handleMouseMove = (e) => {
//     const card = cardRef.current;
//     const rect = card.getBoundingClientRect();

//     const mouseX = e.clientX - rect.left - rect.width / 2;
//     const mouseY = e.clientY - rect.top - rect.height / 2;

//     setTransform({
//       rotateX: -(mouseY / rect.height) * 30,
//       rotateY: (mouseX / rect.width) * 30,
//       translateX: (mouseX / rect.width) * -40,
//       translateY: (mouseY / rect.height) * -40,
//     });
//   };

//   const handleMouseLeave = () => {
//     setTransform({
//       rotateX: 0,
//       rotateY: 0,
//       translateX: 0,
//       translateY: 0,
//     });
//   };

//   return (
//     <div
//       className="card-wrap"
//       ref={cardRef}
//       onMouseMove={handleMouseMove}
//       onMouseLeave={handleMouseLeave}
//     >
//       <div
//         className="card"
//         style={{
//           transform: `rotateY(${transform.rotateY}deg) rotateX(${transform.rotateX}deg)`,
//         }}
//       >
//         <div
//           className="card-bg"
//           style={{
//             backgroundImage: `url(${image})`,
//             transform: `translateX(${transform.translateX}px) translateY(${transform.translateY}px)`,
//           }}
//         />

//         <div className="card-info">
//           <h1>{title}</h1>
//           <p onClick={() =>navigate("/our-services", {state: { activeSection },})}>{content}</p>

//           <button className="card-btn" id="Service-btn"onClick={() =>navigate("/our-services", {state: { activeSection },})}>
//             Read More
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Services = () => {
//   const cards = [
//     {
//       image:
//         "https://primary.jwwb.nl/pexels/19/19825346.jpeg?enable-io=true&crop=1.3333%3A1&width=532",
//       title: "CQC Services",
//       content:
//         "Navigate complex regulations and improve your CQC ratings with our expert guidance. We help ensure your services meet and exceed national standards.",
//       activeSection: "cqc-services",
//     },
//     {
//       image:
//         "https://primary.jwwb.nl/pexels/78/7876379.jpeg?enable-io=true&crop=1.3333%3A1&width=532",
//       title: "Care Home Sales",
//       content:
//         "Our Care Home Sales service provides expert guidance throughout the buying and selling process, helping owners maximise value, ensure compliance",
//       activeSection: "care-home-sales",
//     },
//     {
//       image:
//         "https://plus.unsplash.com/premium_photo-1661761077411-d50cba031848",
//       title: "Accounting",
//       content:
//         "Our specialist Accountancy Services for the care industry provide tailored financial support, helping providers manage finances efficiently, maintain compliance,",
//       activeSection: "accounting",
//     },
//     {
//       image:
//         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRnb9YuXBp_jzaE5AOlAteiGP5lsCWY7O8nfw&s",
//       title: "Software",
//       content:
//         "Our care sector software solutions streamline scheduling, governance, auditing. Our full ERP system provides all-round efficiency to maintain compliance",
//       activeSection: "software",
//     },
//     {
//       image:
//         "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/care-staff-high.jpg?enable-io=true&crop=1.3324%3A1%2Coffset-x37&width=532",
//       title: "Operational Management",
//       content:
//         "We deliver face-to-face training for care professionals, covering moving and handling, medication,and first aid, helping teams build confidence, stay compliant",
//       activeSection: "operational-management",
//     },
//   ];

//   return (
//     <section className="Services">
//       <h1 className="title">Our Tailored Services</h1>
//       <p className="Services-pera">We offer a comprehensive range of advisory services designed to meet the unique needs of your care business, from start-ups to established healthcare providers.</p>

//       <div className="container">
//         {cards.map((card) => (
//           <Card
//             key={card.activeSection}
//             image={card.image}
//             title={card.title}
//             content={card.content}
//             activeSection={card.activeSection}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Services;